import { ERepair } from '../../../../api-models/common/json_query';

export const MATERIALS_MAP_VALUE_TO_LABEL = {
  [ERepair.Cosmetic]: 'Косметический ремонт',
  [ERepair.Design]: 'Дизайнерский ремонт',
  [ERepair.Euro]: 'Евроремонт',
  [ERepair.Without]: 'Без ремонта',
};
